import { UserPermission } from './user-permission';

export class UserRole {
    RoleId: number;
    RoleName: string;
    Permissions: UserPermission[];
    CreatedDate: Date;
    CreatedBy: number;
    UpdatedDate: Date;
    UpdatedBy: number;
}
